import { Card, CardHeader, CardContent, makeStyles, CircularProgress } from '@material-ui/core'
import { useMemo } from 'react'
import { formatNumsToDollars } from '../../utils'
import InvoiceTable from '../Tables/InvoiceTable'

const useStyles = makeStyles(() => ({
	root: {
		position: 'relative'
	},
	cardContent: {
		display: 'flex',
		flexDirection: 'column'
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		gap: '1rem'
	},
	spinnerContainer: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.6)'
	}
}))

const TrainingInvoiceCard = ({ line_items = [], loading = false }) => {
	const classes = useStyles()

	const total = useMemo(() => {
		return line_items.reduce((acc, item) => {
			let amount = acc
			if (item.amount) {
				amount += item.amount
			}
			if (item.upcharge) {
				amount += item.upcharge
			}
			return amount
		}, 0)
	}, [line_items])

	const failedChargeAmount = useMemo(() => {
		return line_items.reduce((acc, item) => {
			let amount = acc
			if (item.stripe_charge_status === 'failed') {
				if (item.amount) {
					amount += item.amount
				}
				if (item.upcharge) {
					amount += item.upcharge
				}
			}
			return amount
		}, 0)
	}, [line_items])

	return (
		<Card className={classes.root}>
			{loading ? (
				<div className={classes.spinnerContainer}>
					<CircularProgress />
				</div>
			) : null}
			<CardHeader title="Invoice" />
			<CardContent className={classes.cardContent}>
				<InvoiceTable showTitle={false} showToolbar={false} invoice={line_items} />
				<div className={classes.row}>
					<span>
						<strong>Total:</strong>
					</span>
					<span>{formatNumsToDollars(total)}</span>
				</div>
				{failedChargeAmount > 0 ? (
					<div className={classes.row}>
						<span>
							<strong>Amount Due:</strong>
						</span>
						<span>{formatNumsToDollars(failedChargeAmount)}</span>
					</div>
				) : null}
			</CardContent>
		</Card>
	)
}

export default TrainingInvoiceCard
